import React, { Component } from "react";
import _ from "lodash";
import Fuse from "fuse.js";
import { connect } from "react-redux";
import { Query } from "react-apollo";
import { selectOrder, deselectOrder } from "../../../actions/select_actions";
import { ordersByShipmentId } from "../../../queries/orders";
import { Box } from "reflexbox";

import ShipmentInfoTextField from "../../Shipments/_ShipmentInfoTextField";
import ShipmentDetailsPanel from "../../Shipments/_ShipmentDetailsPanel";
import OrdersByShipmentTableCommandBar from "./_OrdersByShipmentTableCommandBar";
import { _columns } from "./_OrdersByShipmentTableColumns";

import { injectPallets } from "../../../utils/";

import {
  DetailsList,
  DetailsRow,
  Selection,
  ConstrainMode
} from "office-ui-fabric-react/lib/DetailsList";

const fuseConfig = {
  caseSensitive: false,
  tokenize: true,
  shouldSort: true,
  threshold: 0.1,
  keys: [
    "relationBySellerId.code",
    "relationByBuyerId.code",
    "boxes",
    "awb",
    "origin",
    "packingTypeByPackingId.type",
    "cargoTypeByCargoTypeId.code"
  ]
};

class OrdersByShipment extends Component {
  constructor(props) {
    super();

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({ selectedItems: this._selection.getSelection() });
      }
    });

    this.state = {
      prevProps: [],
      items: [],
      selectedItems: [],
      columns: _columns
    };
  }

  static getDerivedStateFromProps(props, state) {
    const prevProps = state.prevProps;
    
    if (prevProps.items !== props.items) {
      return { items: props.items, prevProps: props };
    } else return null;
  }

  _handleSearch = text => {
    const fuse = new Fuse(this.state.items, fuseConfig);
    this.setState({ items: text ? fuse.search(text) : this.props.items });
  };

  _onColumnClick = (event, column) => {
    let { items, columns } = this.state;
    let isSortedDescending = column.isSortedDescending;
    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }
    if (isSortedDescending) {
      items = _.sortBy(items, column.fieldName);
    } else {
      items = _.reverse(_.sortBy(items, column.fieldName));
    }
    this.setState({
      sortingColumn: column,
      items: items,
      columns: columns.map(col => {
        col.isSorted = col.key === column.key;
        if (col.isSorted) {
          col.isSortedDescending = isSortedDescending;
        }
        return col;
      })
    });
  };

  _onRenderRow = props => {
    const tags = JSON.parse(props.item.tags);
    return (
      <div>
        <DetailsRow
          className={tags && tags.loaded ? "loadedTag-Row" : ""}
          {...props}
        />
      </div>
    );
  };

  render() {
    return (
      <Box mt={1}>
        <Box flex align="center">
          <Box w={0.5}>
            <OrdersByShipmentTableCommandBar
              items={this.state.items}
              selectedItems={this.state.selectedItems}
              handleSearch={this._handleSearch}
              shipment={this.props.shipment}
            />
          </Box>
          <Box mr={1} ml={1} auto>
            <ShipmentInfoTextField />
          </Box>
        </Box>
        <Box mt={1}>
          <div className="list-container-planning" data-is-scrollable={true}>
            <DetailsList
              className="list-body"
              items={this.state.items}
              setKey={this.props.shipmentId}
              columns={this.state.columns}
              compact
              // enableShimmer={true}
              constrainMode={ConstrainMode.horizontalConstrained}
              layoutMode={ConstrainMode.justified}
              selectionPreservedOnEmptyClick={true}
              selection={this._selection}
              onColumnHeaderClick={this._onColumnClick}
              onRenderRow={this._onRenderRow}
              onActiveItemChanged={(item, index) =>
                this.props.selectOrder(item)
              }
            />
          </div>
        </Box>
        <Box mt={1}>
          <ShipmentDetailsPanel
            items={this.state.items}
            selectedItems={this.state.selectedItems}
          />
        </Box>
      </Box>
    );
  }
}

class OrdersByShipmentTable extends Component {
  render() {
    const { selectOrder, deselectOrder, shipment, shipmentId } = this.props;

    return (
      <Query
        query={ordersByShipmentId}
        variables={{
          id: this.props.shipment.id
        }}
        skip={!this.props.shipment.id}
        pollInterval={25000}
      >
        {({ loading, error, data }) => {
          if (!this.props.shipment.id) return <p>select shipment</p>;
          if (loading) return <p>Loading...</p>;
          if (error) return <p>Error :(</p>;

          let items = _.orderBy(
            injectPallets(data.allOrders.nodes),
            ["relationBySellerId.code"],
            [" asc"]
          );

          return (
            <OrdersByShipment
              items={items}
              shipmentId={shipmentId}
              shipment={shipment}
              selectOrder={selectOrder}
              deselectOrder={deselectOrder}
            />
          );
        }}
      </Query>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps, {
  selectOrder: selectOrder,
  deselectOrder: deselectOrder
})(OrdersByShipmentTable);



// WEBPACK FOOTER //
// ./src/views/Orders/Table/_OrdersByShipmentTable.js